// "Thursday, 19 Sep · 4:30 pm", in the viewer's own time zone — family abroad see their time, not India's — with
// the zone named when it is not India's.
export function formatWhen(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const day = new Intl.DateTimeFormat("en-IN", { weekday: "long", day: "numeric", month: "short" }).format(d);
  const time = new Intl.DateTimeFormat("en-IN", { hour: "numeric", minute: "2-digit", hour12: true }).format(d).replace(/\s?([ap])m/i, " $1m").toLowerCase();
  const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const tail = zone === "Asia/Kolkata" || zone === "Asia/Calcutta" ? "" : ` (${zone.split("/").pop().replace(/_/g, " ")})`;
  return `${day} · ${time}${tail}`;
}

// "6:12 pm" — a time today, as a Huddle's close is said (D146 A), in the viewer's own zone.
export function formatTime(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return new Intl.DateTimeFormat("en-IN", { hour: "numeric", minute: "2-digit", hour12: true }).format(d).replace(/\s?([ap])m/i, " $1m").toLowerCase();
}

// What a Huddle past its close says (D146 A), on its own link's page and on the room link's: whose it was, until when,
// and who to ask. Null for anything that is not a closed Huddle.
export function huddleClosed(meeting, win) {
  if (win?.state !== "over" || !win.closesAt) return null;
  return { button: "This huddle has closed", line: `${meeting.hostName}'s huddle was open until ${formatTime(win.closesAt)}. Ask them for a new one.` };
}

export function clock(seconds) {
  const s = Math.max(0, Math.floor(seconds));
  const hh = Math.floor(s / 3600), mm = Math.floor((s % 3600) / 60), ss = s % 60;
  const two = (n) => String(n).padStart(2, "0");
  return hh ? `${hh}:${two(mm)}:${two(ss)}` : `${two(mm)}:${two(ss)}`;
}
